export default __webpack_public_path__ + "static/media/icon-button-close.a5699b82.svg";